import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import StatusBadge from '@/components/badges/StatusBadge.vue'
import { useReference } from '@/core/composables/useReference'
import { toRefs } from 'vue'

interface Props {
  reference: ReferenceInterface
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceStatusBadge'
},
  __name: 'ReferenceStatusBadge',
  props: {
    reference: {}
  },
  setup(__props: any) {

const props = __props

const { reference } = toRefs(props)



const {
  referenceAmount,
  statusIcon: icon,
  statusVariant: variant
} = useReference(reference)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatusBadge, {
    variant: _unref(variant),
    icon: _unref(icon),
    text: _unref(referenceAmount)
  }, null, 8, ["variant", "icon", "text"]))
}
}

})